<template>
    <v-container v-if="suggestions" class="mt-5">
        <v-card class="default_card large">
            <v-data-table
                :headers="headers"
                :items="suggestions"
                class="table"
                fixed-header
                max-height="60vh"
                hide-default-footer
            >
                <template #item="{ item }">
                    <tr>
                        <td class="text-center">{{ getType(item) }}</td>
                        <td class="text-center">{{ getAccountableAccountName(item) }}</td>
                        <td class="text-left">{{ getAccountableAccountDescription(item) }}</td>
                        <td class="text-left">{{ item.count }}</td>
                        <td class="text-center">{{ item.status }}</td>
                        <td class="text-center">
                            <v-btn
                                size="small"
                                variant="text"
                                color="red"
                                v-if="
                                    item.status === 'VALIDATED' ||
                                    item.status === 'PENDING_VALIDATION'
                                "
                                @click="invalidate(item)"
                            >
                                <v-icon>$highlight_off</v-icon>
                            </v-btn>
                            <v-btn
                                size="small"
                                variant="text"
                                color="green"
                                v-if="
                                    item.status === 'INVALIDATED' ||
                                    item.status === 'PENDING_VALIDATION'
                                "
                                @click="validate(item)"
                            >
                                <v-icon>$check_circle_outline</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { CompanyActivitySuggestion } from "../../../../types/types/indexTypes";

@Component
export class Suggestions extends Vue {
    /**
     * @param {[any]} id ID de l'objet père
     */

    @Prop({ default: undefined }) suggestions: CompanyActivitySuggestion[];

    headers: Array<any> = [
        { title: "Type", value: "type", sortable: false, align: "center" },
        { title: "Nom", value: "name", sortable: false, align: "center" },
        { title: "Description", value: "description", sortable: false, align: "left" },
        { title: "Nombre", value: "count", sortable: false, align: "left" },
        { title: "Statut", value: "status", sortable: false, align: "center" },
        { title: "Action", value: "", sortable: false, align: "center" },
    ];

    getType(item) {
        if (item) {
            if (item.purchaseAccount) {
                return "Purchase";
            }
            if (item.salesAccount) {
                return "Sales";
            }
        }
        return "ERROR";
    }

    getAccountableAccountName(item) {
        if (item) {
            if (item.purchaseAccount) {
                return item.purchaseAccount.name;
            }
            if (item.salesAccount) {
                return item.salesAccount.name;
            }
        }
        return "ERROR";
    }

    getAccountableAccountDescription(item) {
        if (item) {
            if (item.purchaseAccount) {
                return item.purchaseAccount.description;
            }
            if (item.salesAccount) {
                return item.salesAccount.description;
            }
        }
        return "ERROR";
    }

    validate(item: any) {
        this.$emit("change-status", {
            id: item.id,
            status: "VALIDATED",
        });
        for (let i = 0; i < this.suggestions.length; i++) {
            if (this.suggestions[i].id === item.id) {
                this.suggestions[i].status = "VALIDATED";
                break;
            }
        }
    }

    invalidate(item: any) {
        this.$emit("change-status", {
            id: item.id,
            status: "INVALIDATED",
        });

        for (let i = 0; i < this.suggestions.length; i++) {
            if (this.suggestions[i].id === item.id) {
                this.suggestions[i].status = "INVALIDATED";
                break;
            }
        }
    }
}

export default toNative(Suggestions);
</script>

<style></style>
